

import { createReducer } from '../helpers';

import { ModalsActionTypes } from '../actions/types';

const initialState = {
  projectCreated: {
    isOpen: false,
    data: {},
  },
  unsuitableWriter: {
    isOpen: false,
  },
  existingUser: {
    isOpen: false,
  },
  unableToUpdateRole: {
    isOpen: false,
  },
  thankYouForApprovingDraft: {
    isOpen: false,
  },
  writerConfirmedOnProject: {
    isOpen: false,
    data: {},
  },
  sendToPrinter: {
    isOpen: false,
  },
  successfullySentToPrinter: {
    isOpen: false,
  },
  scheduleInterview: {
    isOpen: false,
  },
  editorFeedbackToWriter: {
    isOpen: false,
  },
  draftIsUpdatedByWriter: {
    isOpen: false,
  },
  draftEditedByCustomer: {
    isOpen: false,
  },
  completeInterview: {
    isOpen: false,
  },
  cancelInterview: {
    isOpen: false,
  },
  confirmInterview: {
    isOpen: false,
  },
  editInterviewNote: {
    isOpen: false,
  },
  customerOutlineOnboarding: {
    isOpen: false,
  },
  outlineSubmitted: {
    isOpen: false,
  },
  thankYouForApprovingOutline: {
    isOpen: false,
  },
  proofApprovedByCustomer: {
    isOpen: false,
  },
  proofApprovedByEditor: {
    isOpen: false,
  },
  redirectToRateWriter: {
    isOpen: false,
  },
  rateUser: {
    isOpen: false,
  },
  firstInterviewScheduled: {
    isOpen: false,
  },
  onboarding: {
    isOpen: false,
  },
  draftApprovedByCustomer: {
    isOpen: false,
  },
  draftApprovedByWriter: {
    isOpen: false,
  },
  draftApprovedByEditor: {
    isOpen: false,
  },
  rateOutline: {
    isOpen: false,
  },
  rateBookOutline: {
    isOpen: false,
  },
  rateDraft: {
    isOpen: false,
  },
  deleteCoverPhotos: {
    isOpen: false,
  },
  useTimeline: {
    isOpen: false,
  },
  coverNotification: {
    isOpen: false,
  },
  hubspot: {
    isOpen: false,
  },
  upgradeRequestedModal: {
    isOpen: false,
  },
  packageUpgradeRequest: {
    isOpen: false,
  },
  upgradeRequestCompleted: {
    isOpen: false,
  },
  questionnaireSent: {
    isOpen: false,
  },
  rateWriterByDevelopmentalEditor: {
    isOpen: false,
  },
  rateProofByCustomer: {
    isOpen: false,
  },
  onboardingFeedback: {
    isOpen: false,
  },
  confirmSampleApproval: {
    isOpen: false,
  },
  thankYouForApprovingSample: {
    isOpen: false,
  },
  chatbotInfo: {
    isOpen: false,
  },
  thankYouForApprovingStyleSample: {
    isOpen: false,
  },
  extensionFeePayment: {
    isOpen: false,
  },
  customerAccessToProjectBlocked: {
    isOpen: false,
  },
  activeSubscriptionWarn: {
    isOpen: false,
  },
  accessToProjectBlocked: {
    isOpen: false,
  },
  rateByWriter: {
    isOpen: false,
  },
  transcribeAudioFile: {
    isOpen: false,
  },
  restoreVersion: {
    isOpen: false,
  },
  editorProofNotReady: {
    isOpen: false,
  },
  noAddressForCustomer: {
    isOpen: false,
  },
  requestReview: {
    isOpen: false,
  },
};

const modalsReducer = createReducer(
  initialState,
  {
    [ModalsActionTypes.openProjectCreated]: (state, action) => ({ ...state, projectCreated: { isOpen: true, data: action.payload.data } }),
    [ModalsActionTypes.closeProjectCreated]: (state, action) => ({ ...state, projectCreated: { isOpen: false, data: {} } }),
    [ModalsActionTypes.openUnsuitableWriter]: (state, action) => ({ ...state, unsuitableWriter: { isOpen: true } }),
    [ModalsActionTypes.closeUnsuitableWriter]: (state, action) => ({ ...state, unsuitableWriter: { isOpen: false } }),
    [ModalsActionTypes.openExistingUser]: (state, action) => ({ ...state, existingUser: { isOpen: true } }),
    [ModalsActionTypes.closeExistingUser]: (state, action) => ({ ...state, existingUser: { isOpen: false } }),
    [ModalsActionTypes.openUnableToUpdateRole]: (state, action) => ({ ...state, unableToUpdateRole: { isOpen: true } }),
    [ModalsActionTypes.closeUnableToUpdateRole]: (state, action) => ({ ...state, unableToUpdateRole: { isOpen: false } }),
    [ModalsActionTypes.openThankYouForApprovingDraft]: (state, action) => ({ ...state, thankYouForApprovingDraft: { isOpen: true } }),
    [ModalsActionTypes.closeThankYouForApprovingDraft]: (state, action) => ({ ...state, thankYouForApprovingDraft: { isOpen: false } }),
    [ModalsActionTypes.openWriterConfirmedOnProject]: (state, action) => ({ ...state, writerConfirmedOnProject: { isOpen: true, data: action.payload.data } }),
    [ModalsActionTypes.closeWriterConfirmedOnProject]: (state, action) => ({ ...state, writerConfirmedOnProject: { isOpen: false, data: {} } }),
    [ModalsActionTypes.openSendToPrinterModal]: state => ({ ...state, sendToPrinter: { isOpen: true } }),
    [ModalsActionTypes.closeSendToPrinterModal]: state => ({ ...state, sendToPrinter: { isOpen: false } }),
    [ModalsActionTypes.openSuccessfullySentToPrinterModal]: state => ({ ...state, successfullySentToPrinter: { isOpen: true } }),
    [ModalsActionTypes.closeSuccessfullySentToPrinterModal]: state => ({ ...state, successfullySentToPrinter: { isOpen: false } }),
    [ModalsActionTypes.openScheduleInterviewModal]: state => ({ ...state, scheduleInterview: { isOpen: true } }),
    [ModalsActionTypes.closeScheduleInterviewModal]: state => ({ ...state, scheduleInterview: { isOpen: false } }),
    [ModalsActionTypes.openEditorFeedbackToWriterModal]: state => ({ ...state, editorFeedbackToWriter: { isOpen: true } }),
    [ModalsActionTypes.closeEditorFeedbackToWriterModal]: state => ({ ...state, editorFeedbackToWriter: { isOpen: false } }),
    [ModalsActionTypes.openDraftIsUpdatedByWriterModal]: state => ({ ...state, draftIsUpdatedByWriter: { isOpen: true } }),
    [ModalsActionTypes.closeDraftIsUpdatedByWriterModal]: state => ({ ...state, draftIsUpdatedByWriter: { isOpen: false } }),
    [ModalsActionTypes.openDraftEditedByCustomerModal]: state => ({ ...state, draftEditedByCustomer: { isOpen: true } }),
    [ModalsActionTypes.closeDraftEditedByCustomerModal]: state => ({ ...state, draftEditedByCustomer: { isOpen: false } }),
    [ModalsActionTypes.openCompleteInterviewModal]: state => ({ ...state, completeInterview: { isOpen: true } }),
    [ModalsActionTypes.closeCompleteInterviewModal]: state => ({ ...state, completeInterview: { isOpen: false } }),
    [ModalsActionTypes.openCancelInterviewModal]: state => ({ ...state, cancelInterview: { isOpen: true } }),
    [ModalsActionTypes.closeCancelInterviewModal]: state => ({ ...state, cancelInterview: { isOpen: false } }),
    [ModalsActionTypes.openConfirmInterviewModal]: state => ({ ...state, confirmInterview: { isOpen: true } }),
    [ModalsActionTypes.closeConfirmInterviewModal]: state => ({ ...state, confirmInterview: { isOpen: false } }),
    [ModalsActionTypes.openEditInterviewNoteModal]: state => ({ ...state, editInterviewNote: { isOpen: true } }),
    [ModalsActionTypes.closeEditInterviewNoteModal]: state => ({ ...state, editInterviewNote: { isOpen: false } }),
    [ModalsActionTypes.openCustomerOutlineOnboardingModal]: state => ({ ...state, customerOutlineOnboarding: { isOpen: true } }),
    [ModalsActionTypes.closeCustomerOutlineOnboardingModal]: state => ({ ...state, customerOutlineOnboarding: { isOpen: false } }),
    [ModalsActionTypes.openOutlineSubmittedModal]: state => ({ ...state, outlineSubmitted: { isOpen: true } }),
    [ModalsActionTypes.closeOutlineSubmittedModal]: state => ({ ...state, outlineSubmitted: { isOpen: false } }),
    [ModalsActionTypes.openThankYouForApprovingOutlineModal]: state => ({ ...state, thankYouForApprovingOutline: { isOpen: true } }),
    [ModalsActionTypes.closeThankYouForApprovingOutlineModal]: state => ({ ...state, thankYouForApprovingOutline: { isOpen: false } }),
    [ModalsActionTypes.openProofApprovedByCustomerModal]: state => ({ ...state, proofApprovedByCustomer: { isOpen: true } }),
    [ModalsActionTypes.closeProofApprovedByCustomerModal]: state => ({ ...state, proofApprovedByCustomer: { isOpen: false } }),
    [ModalsActionTypes.openProofApprovedByEditorModal]: state => ({ ...state, proofApprovedByEditor: { isOpen: true } }),
    [ModalsActionTypes.closeProofApprovedByEditorModal]: state => ({ ...state, proofApprovedByEditor: { isOpen: false } }),
    [ModalsActionTypes.openRedirectToRateWriterModal]: state => ({ ...state, redirectToRateWriter: { isOpen: true } }),
    [ModalsActionTypes.closeRedirectToRateWriterModal]: state => ({ ...state, redirectToRateWriter: { isOpen: false } }),
    [ModalsActionTypes.openRateUserModal]: state => ({ ...state, rateUser: { isOpen: true } }),
    [ModalsActionTypes.closeRateUserModal]: state => ({ ...state, rateUser: { isOpen: false } }),
    [ModalsActionTypes.openFirstInterviewScheduledModal]: state => ({ ...state, firstInterviewScheduled: { isOpen: true } }),
    [ModalsActionTypes.closeFirstInterviewScheduledModal]: state => ({ ...state, firstInterviewScheduled: { isOpen: false } }),
    [ModalsActionTypes.openOnboardingModal]: state => ({ ...state, onboarding: { isOpen: true } }),
    [ModalsActionTypes.closeOnboardingModal]: state => ({ ...state, onboarding: { isOpen: false } }),
    [ModalsActionTypes.openDraftApprovedByCustomerModal]: state => ({ ...state, draftApprovedByCustomer: { isOpen: true } }),
    [ModalsActionTypes.closeDraftApprovedByCustomerModal]: state => ({ ...state, draftApprovedByCustomer: { isOpen: false } }),
    [ModalsActionTypes.openDraftApprovedByWriterModal]: state => ({ ...state, draftApprovedByWriter: { isOpen: true } }),
    [ModalsActionTypes.closeDraftApprovedByWriterModal]: state => ({ ...state, draftApprovedByWriter: { isOpen: false } }),
    [ModalsActionTypes.openDraftApprovedByEditorModal]: state => ({ ...state, draftApprovedByEditor: { isOpen: true } }),
    [ModalsActionTypes.closeDraftApprovedByEditorModal]: state => ({ ...state, draftApprovedByEditor: { isOpen: false } }),
    [ModalsActionTypes.openRateOutlineModal]: state => ({ ...state, rateOutline: { isOpen: true } }),
    [ModalsActionTypes.closeRateOutlineModal]: state => ({ ...state, rateOutline: { isOpen: false } }),
    [ModalsActionTypes.openRateBookOutlineModal]: state => ({ ...state, rateBookOutline: { isOpen: true } }),
    [ModalsActionTypes.closeRateBookOutlineModal]: state => ({ ...state, rateBookOutline: { isOpen: false } }),
    [ModalsActionTypes.openRateDraftModal]: state => ({ ...state, rateDraft: { isOpen: true } }),
    [ModalsActionTypes.closeRateDraftModal]: state => ({ ...state, rateDraft: { isOpen: false } }),
    [ModalsActionTypes.openDeleteCoverPhotosModal]: state => ({ ...state, deleteCoverPhotos: { isOpen: true } }),
    [ModalsActionTypes.closeDeleteCoverPhotosModal]: state => ({ ...state, deleteCoverPhotos: { isOpen: false } }),
    [ModalsActionTypes.openUseTimelineModal]: state => ({ ...state, useTimeline: { isOpen: true } }),
    [ModalsActionTypes.closeUseTimelineModal]: state => ({ ...state, useTimeline: { isOpen: false } }),
    [ModalsActionTypes.openCoverNotificationModal]: state => ({ ...state, coverNotification: { isOpen: true } }),
    [ModalsActionTypes.closeCoverNotificationModal]: state => ({ ...state, coverNotification: { isOpen: false } }),
    [ModalsActionTypes.openHubspotModal]: state => ({ ...state, hubspot: { isOpen: true } }),
    [ModalsActionTypes.closeHubspotModal]: state => ({ ...state, hubspot: { isOpen: false } }),
    [ModalsActionTypes.openUpgradeRequestedModal]: state => ({ ...state, upgradeRequestedModal: { isOpen: true } }),
    [ModalsActionTypes.closeUpgradeRequestedModal]: state => ({ ...state, upgradeRequestedModal: { isOpen: false } }),
    [ModalsActionTypes.openPackageUpgradeRequestModal]: state => ({ ...state, packageUpgradeRequest: { isOpen: true } }),
    [ModalsActionTypes.closePackageUpgradeRequestModal]: state => ({ ...state, packageUpgradeRequest: { isOpen: false } }),
    [ModalsActionTypes.openUpgradeRequestCompletedModal]: state => ({ ...state, upgradeRequestCompleted: { isOpen: true } }),
    [ModalsActionTypes.closeUpgradeRequestCompletedModal]: state => ({ ...state, upgradeRequestCompleted: { isOpen: false } }),
    [ModalsActionTypes.openActiveSubscriptionWarnModal]: state => ({ ...state, activeSubscriptionWarn: { isOpen: true } }),
    [ModalsActionTypes.closeActiveSubscriptionWarnModal]: state => ({ ...state, activeSubscriptionWarn: { isOpen: false } }),
    [ModalsActionTypes.openQuestionnaireSentModal]: state => ({ ...state, questionnaireSent: { isOpen: true } }),
    [ModalsActionTypes.closeQuestionnaireSentModal]: state => ({ ...state, questionnaireSent: { isOpen: false } }),
    [ModalsActionTypes.openRateWriterByDevelopmentalEditorModal]: state => ({ ...state, rateWriterByDevelopmentalEditor: { isOpen: true } }),
    [ModalsActionTypes.closeRateWriterByDevelopmentalEditorModal]: state => ({ ...state, rateWriterByDevelopmentalEditor: { isOpen: false } }),
    [ModalsActionTypes.openRateProofByCustomerModal]: state => ({ ...state, rateProofByCustomer: { isOpen: true } }),
    [ModalsActionTypes.closeRateProofByCustomerModal]: state => ({ ...state, rateProofByCustomer: { isOpen: false } }),
    [ModalsActionTypes.openOnboardingFeedbackModal]: state => ({ ...state, onboardingFeedback: { isOpen: true } }),
    [ModalsActionTypes.closeOnboardingFeedbackModal]: state => ({ ...state, onboardingFeedback: { isOpen: false } }),
    [ModalsActionTypes.openConfirmSampleApprovalModal]: state => ({ ...state, confirmSampleApproval: { isOpen: true } }),
    [ModalsActionTypes.closeConfirmSampleApprovalModal]: state => ({ ...state, confirmSampleApproval: { isOpen: false } }),
    [ModalsActionTypes.openThankYouForApprovingSampleModal]: state => ({ ...state, thankYouForApprovingSample: { isOpen: true } }),
    [ModalsActionTypes.closeThankYouForApprovingSampleModal]: state => ({ ...state, thankYouForApprovingSample: { isOpen: false } }),
    [ModalsActionTypes.openChatBotInfoModal]: state => ({ ...state, chatbotInfo: { isOpen: true } }),
    [ModalsActionTypes.closeChatBotInfoModal]: state => ({ ...state, chatbotInfo: { isOpen: false } }),
    [ModalsActionTypes.openThankYouForStyleSampleApprovalModal]: (state) => (
      { ...state, thankYouForApprovingStyleSample: { isOpen: true } }
    ),
    [ModalsActionTypes.closeThankYouForStyleSampleApprovalModal]: (state) => (
      { ...state, thankYouForApprovingStyleSample: { isOpen: false } }
    ),
    [ModalsActionTypes.openExtensionFeePaymentModal]: (state) => (
      { ...state, extensionFeePayment: { isOpen: true } }
    ),
    [ModalsActionTypes.closeExtensionFeePaymentModal]: (state) => (
      { ...state, extensionFeePayment: { isOpen: false } }
    ),
    [ModalsActionTypes.openCustomerAccessToProjectBlockedModal]: (state) => (
      { ...state, customerAccessToProjectBlocked: { isOpen: true } }
    ),
    [ModalsActionTypes.closeCustomerAccessToProjectBlockedModal]: (state) => (
      { ...state, customerAccessToProjectBlocked: { isOpen: false } }
    ),
    [ModalsActionTypes.openAccessToProjectBlockedModal]: (state) => (
      { ...state, accessToProjectBlocked: { isOpen: true } }
    ),
    [ModalsActionTypes.closeAccessToProjectBlockedModal]: (state) => (
      { ...state, accessToProjectBlocked: { isOpen: false } }
    ),
    [ModalsActionTypes.openRateByWriterModal]: (state) => ({ ...state, rateByWriter: { isOpen: true } }),
    [ModalsActionTypes.closeRateByWriterModal]: (state) => ({ ...state, rateByWriter: { isOpen: false } }),
    [ModalsActionTypes.openTranscribeAudioFileModal]: (state) => (
      { ...state, transcribeAudioFile: { isOpen: true } }
    ),
    [ModalsActionTypes.closeTranscribeAudioFileModal]: (state) => (
      { ...state, transcribeAudioFile: { isOpen: false } }
    ),
    [ModalsActionTypes.openRestoreVersionModal]: (state) => ({ ...state, restoreVersion: { isOpen: true } }),
    [ModalsActionTypes.closeRestoreVersionModal]: (state) => ({ ...state, restoreVersion: { isOpen: false } }),
    [ModalsActionTypes.openEditorProofNotReadyModal]: (state) => (
      { ...state, editorProofNotReady: { isOpen: true } }
    ),
    [ModalsActionTypes.closeEditorProofNotReadyModal]: (state) => (
      { ...state, editorProofNotReady: { isOpen: false } }
    ),
    [ModalsActionTypes.openNoAddressForCustomerModal]: (state) => ({ ...state, noAddressForCustomer: { isOpen: true } }),
    [ModalsActionTypes.closeNoAddressForCustomerModal]: (state) => ({ ...state, noAddressForCustomer: { isOpen: false } }),
    [ModalsActionTypes.openRequestReviewModal]: (state) => ({ ...state, requestReview: { isOpen: true } }),
    [ModalsActionTypes.closeRequestReviewModal]: (state) => ({ ...state, requestReview: { isOpen: false } }),
  },
);

export default modalsReducer;
